import Service from 'react-reservice';

import { IAccountExperienceResetPassword } from '@aqx-core/common/api/account-experience';

import { EResetPasswordExperienceContent } from './types';

export interface IResetPasswordExperienceServiceContext {
  loading: boolean;
  content: EResetPasswordExperienceContent;
  details: IAccountExperienceResetPassword | undefined;
}

const defaultContext: IResetPasswordExperienceServiceContext = {
  loading: false,
  content: EResetPasswordExperienceContent.FORM,
  details: undefined
};

class ResetPasswordExperienceService extends Service<IResetPasswordExperienceServiceContext> {
  constructor() {
    super();

    this.context = { ...defaultContext };
  }

  setContent = (content: EResetPasswordExperienceContent) => {
    this.context.content = content;
  };

  setLoading = (loading: boolean) => {
    this.context.loading = loading;
  };

  setDetails = (details: IAccountExperienceResetPassword) => {
    this.context.details = details;
  };

  reset = () => {
    this.context = {
      ...defaultContext
    };
  };
}

export const resetPasswordExperienceService = new ResetPasswordExperienceService();
